export default __webpack_public_path__ + "static/media/youngmindslogo.4a136b89.png";